<script>
  import {createEventDispatcher, onMount} from 'svelte';

  import {format} from 'date-fns';

  import Modal from "../../UI/Modal.svelte";

  import {nombreCompleto} from '../../../Modelos/Trabajador';
  import storeTrabajador from '../../../Stores/Trabajadores/ver-trabajador-store';
  import Icono from "../../UI/Icono.svelte";

  export let marcaje = null;
  export let fecha = null;
  let icono;

  $: trabajador = $storeTrabajador.trabajador.trabajador;
  $: switch (marcaje.origen) {
    case 'Móvil':
      icono = 'smartphone';
      break;
    case 'Tarjeta':
      icono = 'credit_card';
      break;
    default:
      icono = 'computer';
      break;
  }

  const dispatch = createEventDispatcher();

  let mapa;
  onMount(() => {
    if (marcaje.posicion && marcaje.posicion.lat) {
      const map = new google.maps.Map(mapa, {
        zoom: marcaje.origen === 'Ordenador' ? 14 : 17,
        center: marcaje.posicion
      });

      new google.maps.Marker({position: marcaje.posicion, map: map});

      if (marcaje.origen === 'Ordenador') {
        new google.maps.Circle({
          strokeColor: '#ff6600',
          strokeOpacity: .8,
          strokeWeight: 2,
          fillColor: '#26A892',
          fillOpacity: .35,
          map: map,
          center: marcaje.posicion,
          radius: 1300
        })
      }
    }
  });
</script>

<style>
    .marcaje {
        display: grid;
        grid-gap: var(--padding-global);
        grid-template-columns: 1fr;
    }

    .fecha {
        font-weight: 500;
    }

    .datos {
        grid-column: 1;
        grid-row: 1;
        text-align: center;
    }

    .imputacion {
        grid-column: 1;
        grid-row: 2;
        justify-self: center;
    }

    .plano {
        grid-column: 1;
        grid-row: 3;
    }

    .imputacion {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: flex-start;
    }

    .tipo {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: calc(var(--padding-global) / 2);
    }

    .tipo.Entrada {
        color: var(--verde);
    }

    .tipo.Salida {
        color: var(--acentos);
    }

    .hora {
        font-size: 2em;
        font-weight: 500;
    }

    .observaciones {
        --color-icono: var(--rojo);
        width: 100%;
        display: flex;
        align-items: center;
        margin-top: calc(var(--padding-global) / 2);
    }

    .mapa {
        width: 100%;
        height: 100%;
        min-height: 300px;
    }

    @media (max-width: 767px) {
        .datos {
            display: flex;
            justify-content: space-evenly;
        }
    }

    @media (min-width: 768px) {
        .marcaje {
            grid-template-columns: max-content 1fr;
            grid-template-rows: max-content max-content 1fr;
        }

        .datos {
            grid-column: 1;
            grid-row: 1 / 4;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
        }

        .fecha, .empleado, .origen:not(:last-child) {
            margin-bottom: var(--padding-global);
        }

        .imputacion {
            grid-column: 2;
            grid-row: 1;
            justify-self: initial;
            flex-wrap: nowrap;
        }

        .observaciones {
            width: auto;
            padding: 0 0 0 var(--padding-global);
            margin: 0 0 0 auto;
        }

        .plano {
            grid-column: 2;
            grid-row: 2 / 4;
        }
    }
</style>

<Modal on:cancel title="Información del marcaje">
    <div class="marcaje">
        <div class="datos">
            <div class="fecha">
                <Icono tamano={40}>calendar_today</Icono>
                <div>{format(fecha, 'dd/MM/yyyy')}</div>
            </div>
            <div class="empleado">
                <Icono tamano={40}>face</Icono>
                <div>{nombreCompleto(trabajador)}</div>
            </div>
            <div class="origen">
                <Icono tamano={40}>{icono}</Icono>
                <div>{marcaje.origen}</div>
            </div>
            {#if marcaje.sede}
                <div class="sede">
                    <Icono tamano={40}>business</Icono>
                    <div>{marcaje.sede}</div>
                </div>
            {/if}
        </div>

        <div class="imputacion" class:error={marcaje.observaciones}>
            <div class="tipo {marcaje.motivo.tipo}">
                <Icono svg={marcaje.motivo.icono} tamano={40}/>
                <div>{marcaje.motivo.nombre}</div>
            </div>
            <div class="hora">
                {marcaje.hora}
            </div>
            {#if marcaje.observaciones}
                <div class="observaciones">
                    <Icono margen>warning</Icono> {marcaje.observaciones}
                </div>
            {/if}
        </div>

        <div class="plano">
            {#if marcaje.posicion && marcaje.posicion.lat}
                <div bind:this={mapa} class="mapa"></div>
            {:else}
                <p>Marcaje sin posición</p>
            {/if}
        </div>
    </div>
</Modal>